import { ALLOCATION_DIMENSION } from "constants/action-types";
import type {
    IAllocationDimension,
    AllocationDimensionOwnerObject,
    ICreateAllocationDimensionValue,
    IUpdateAllocationDimensionValue,
} from "helpers/allocation-dimension";
import { FluxStandardAction as Action } from "flux-standard-action";

export type CreateAllocationDimensionValueRequestAction = Action<
    {
        index: number;
        allocationDimension: IAllocationDimension;
        allocationDimensionValue: ICreateAllocationDimensionValue;
    },
    {
        objectId: string;
        owner: AllocationDimensionOwnerObject;
    }
>;
export const createAllocationDimensionValueRequest = (
    index: number,
    allocationDimensionValue: ICreateAllocationDimensionValue,
    allocationDimension: IAllocationDimension,
    objectId: string,
    owner: AllocationDimensionOwnerObject
): CreateAllocationDimensionValueRequestAction => ({
    meta: { objectId, owner },
    payload: {
        index,
        allocationDimensionValue,
        allocationDimension,
    },
    type: ALLOCATION_DIMENSION.VALUES.CREATE.REQUEST,
});

export type CreateAllocationDimensionValueCompleteAction = Action<
    IAllocationDimension | Error,
    {
        objectId: string;
        owner: AllocationDimensionOwnerObject;
    }
>;
export const createAllocationDimensionValueComplete = (
    payload: IAllocationDimension | Error,
    objectId: string,
    owner: AllocationDimensionOwnerObject
): CreateAllocationDimensionValueCompleteAction => ({
    meta: { objectId, owner },
    payload,
    error: payload instanceof Error,
    type: ALLOCATION_DIMENSION.VALUES.CREATE.COMPLETE,
});

export type UpdateAllocationDimensionValueRequestAction = Action<
    {
        index: number;
        allocationDimensionValue: IUpdateAllocationDimensionValue;
        allocationDimension: IAllocationDimension;
    },
    {
        objectId: string;
        owner: AllocationDimensionOwnerObject;
    }
>;
export const updateAllocationDimensionValueRequest = (
    index: number,
    allocationDimensionValue: IUpdateAllocationDimensionValue,
    allocationDimension: IAllocationDimension,
    objectId: string,
    owner: AllocationDimensionOwnerObject
): UpdateAllocationDimensionValueRequestAction => ({
    meta: { objectId, owner },
    payload: {
        index,
        allocationDimension,
        allocationDimensionValue,
    },
    type: ALLOCATION_DIMENSION.VALUES.UPDATE.REQUEST,
});

export type UpdateAllocationDimensionValueCompleteAction = Action<
    IAllocationDimension | Error,
    {
        objectId: string;
        owner: AllocationDimensionOwnerObject;
    }
>;
export const updateAllocationDimensionValueComplete = (
    payload: IAllocationDimension | Error,
    objectId: string,
    owner: AllocationDimensionOwnerObject
): UpdateAllocationDimensionValueCompleteAction => ({
    meta: { objectId, owner },
    payload,
    error: payload instanceof Error,
    type: ALLOCATION_DIMENSION.VALUES.UPDATE.COMPLETE,
});

export type SortAllocationDimensionRequestValueAction = Action<
    {
        index: number;
        destinationIndex: number;
        allocationDimension: IAllocationDimension;
    },
    {
        objectId: string;
        owner: AllocationDimensionOwnerObject;
    }
>;
export const sortAllocationDimensionValueRequest = (
    index: number,
    destinationIndex: number,
    allocationDimension: IAllocationDimension,
    objectId: string,
    owner: AllocationDimensionOwnerObject
): SortAllocationDimensionRequestValueAction => ({
    meta: { objectId, owner },
    payload: { allocationDimension, index, destinationIndex },
    type: ALLOCATION_DIMENSION.VALUES.SORT.REQUEST,
});

export type SortAllocationDimensionValueCompleteAction = Action<
    IAllocationDimension | Error,
    {
        objectId: string;
        owner: AllocationDimensionOwnerObject;
    }
>;
export const sortAllocationDimensionValueComplete = (
    payload: IAllocationDimension | Error,
    objectId: string,
    owner: AllocationDimensionOwnerObject
): SortAllocationDimensionValueCompleteAction => ({
    meta: { objectId, owner },
    payload,
    error: payload instanceof Error,
    type: ALLOCATION_DIMENSION.VALUES.SORT.COMPLETE,
});
